module.exports = __webpack_public_path__ + "static/logo3-6a7c1e1e21babeda20f07482ccd69d48.png";